import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ActivateAccountComponent } from './modules/auth-check/activate-account/activate-account.component';
import { BusinessSignUpComponent } from './modules/auth-check/business-sign-up/business-sign-up.component';
import { CustomerSignUpComponent } from './modules/auth-check/customer-sign-up/customer-sign-up.component';
import { SignInComponent } from './modules/auth-check/sign-in/sign-in.component';
import { SignUpComponent } from './modules/auth-check/sign-up/sign-up.component';
import { BlogComponent } from './modules/blog/blog.component';
import { CategoryGroupComponent } from './modules/category/category-group/category-group.component';
import { AboutAvaanaComponent } from './modules/home/about-avaana/about-avaana.component';
import { HomeComponent } from './modules/home/home/home.component';
import { SearchPageComponent } from './modules/service-list/search-page/search-page.component';
import { CollectionStatementsComponent } from './modules/terms/collection-statements/collection-statements.component';
import { CommunityGuidelinesComponent } from './modules/terms/community-guidelines/community-guidelines.component';
import { CustomerTermsComponent } from './modules/terms/customer-terms/customer-terms.component';
import { DisclaimerComponent } from './modules/terms/disclaimer/disclaimer.component';
import { PrivacyPolicyComponent } from './modules/terms/privacy-policy/privacy-policy.component';
import { ProviderTermsComponent } from './modules/terms/provider-terms/provider-terms.component';
import { SiteMapComponent } from './modules/terms/sitemap/sitemap.component';
import { LoginGuard } from './services/login-gaurd';
import { WellbeingGuard } from './services/wellbeing.guard';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [LoginGuard]
  },
  { path: 'notfound', component: NotFoundComponent },
  {
    path: 'login',
    component: SignInComponent
  },
  {
    path: 'sign-up',
    children: [
      {
        path: '',
        component: SignUpComponent
      },
      {
        path: 'customer',
        component: CustomerSignUpComponent
      },
      {
        path: 'business',
        component: BusinessSignUpComponent
      }
    ]
  },
  {
    path: 'maintenance',
    loadChildren: () => import('./modules/maintenance/maintenance.module').then((mod) => mod.MaintenanceModule)
  },
  {
    path: 'business/provider/signup',
    component: BusinessSignUpComponent
  },
  {
    path: 'reset-password/:slug/:token',
    component: ActivateAccountComponent
  },
  {
    path: 'workplacewellbeing',
    loadChildren: () =>
      import('./modules/workplace-wellbeing-site/workplace-wellbeing-site.module').then(
        (mod) => mod.WorkplaceWellbeingSiteModule
      )
  },
  {
    path: 'wellbeing',
    loadChildren: () =>
      import('./modules/wellbeing-dashboard/wellbeing-dashboard.module').then((mod) => mod.WellbeingDashboardModule),
    canActivate: [WellbeingGuard]
  },
  {
    path: 'profile',
    loadChildren: () => import('./modules/profile-new/profile-new.module').then((mod) => mod.ProfileNewModule)
  },
  {
    path: 'about-avaana',
    component: AboutAvaanaComponent
  },
  {
    path: 'sitemap',
    component: SiteMapComponent
  },
  {
    path: 'blog',
    component: BlogComponent
  },
  {
    path: 'disclaimer',
    component: DisclaimerComponent
  },
  {
    path: 'collection-statements',
    component: CollectionStatementsComponent
  },
  {
    path: 'provider-terms',
    component: ProviderTermsComponent
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'booking-terms',
    component: CustomerTermsComponent
  },
  {
    path: 'community-guidelines',
    component: CommunityGuidelinesComponent
  },
  {
    path: 'physical',
    component: CategoryGroupComponent
  },
  {
    path: 'mental',
    component: CategoryGroupComponent
  },
  {
    path: 'natural',
    component: CategoryGroupComponent
  },
  {
    path: 'fitness',
    component: CategoryGroupComponent
  },
  {
    path: 'health-conditions',
    component: CategoryGroupComponent
  },
  {
    path: 'online/:service',
    data: {
      url_type: 'online'
    },
    loadChildren: () => import('./modules/service-list/service-list.module').then((mod) => mod.ServiceListModule)
  },
  {
    path: 'booking',
    loadChildren: () => import('./modules/booking-flow/booking-flow.module').then((mod) => mod.BookingFlowModule)
  },
  // {
  //   path: 'booking/:slug/:service_id/:practitioner_id/:date',
  //   component: BookingComponent
  // },
  // {
  //   path: 'booking/:slug/:service_id/:practitioner_id/:date/:time',
  //   component: BookingComponent
  // },
  {
    path: 'confirm/:appointment_id',
    loadChildren: () =>
      import('./modules/booking-flow/booking-complete-page/booking-complete-page.module').then(
        (mod) => mod.BookingCompletePageModule
      )
  },
  {
    path: 'provider/:provider_name/:suburb',
    loadChildren: () => import('./modules/new-provider/new-provider.module').then((mod) => mod.ProviderModule)
  },
  {
    path: 'search',
    children: [
      {
        path: 'health-condition/:service/:location/:postCode',
        data: {
          url_type: 'symptom'
        },
        component: SearchPageComponent
      },
      {
        path: ':category/:service/:location/:postCode',
        data: {
          url_type: 'service'
        },
        component: SearchPageComponent
      },
      {
        path: ':service/:location/:postCode',
        data: {
          url_type: 'service'
        },
        component: SearchPageComponent
      },
      {
        path: ':service/:location',
        data: {
          url_type: 'service'
        },
        component: SearchPageComponent
      },
      {
        path: ':service',
        data: {
          url_type: 'category'
        },
        component: SearchPageComponent
      }
    ]
  },
  {
    path: 'category',
    children: [
      {
        path: ':category_name',
        data: {
          url_type: 'cat'
        },
        loadChildren: () => import('./modules/category/category.module').then((mod) => mod.CategoryModule)
      },
      {
        path: ':category_name/:city',
        data: {
          url_type: 'cat'
        },
        loadChildren: () => import('./modules/category/category.module').then((mod) => mod.CategoryModule)
      },
      {
        path: ':category_name/:city/:postcode',
        data: {
          url_type: 'cat'
        },
        loadChildren: () => import('./modules/category/category.module').then((mod) => mod.CategoryModule)
      },
      {
        path: ':parent_category/:category_name',
        data: {
          url_type: 'cat'
        },
        loadChildren: () => import('./modules/category/category.module').then((mod) => mod.CategoryModule)
      },
      {
        path: ':parent_category/:category_name/:city',
        data: {
          url_type: 'cat'
        },
        loadChildren: () => import('./modules/category/category.module').then((mod) => mod.CategoryModule)
      },
      {
        path: ':parent_category/:category_name/:city/:postcode',
        data: {
          url_type: 'cat'
        },
        loadChildren: () => import('./modules/category/category.module').then((mod) => mod.CategoryModule)
      }
    ]
  },
  {
    path: 'link',
    loadChildren: () =>
      import('./modules/link-preferences/link-preferences.module').then((mod) => mod.LinkPreferencesModule)
  },
  { path: '**', redirectTo: '/notfound' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
